export const newsItems = [
  {
    newsBadge: "new",
    newsSection: "ข่าวประชาสัมพันธ์",
    newsHeader: "ไทยเป็นเจ้าภาพประชุมปศุสัตว์อาเซียน ครั้งที่ 33 หนุนความร่วมมือภูมิภาคสู่การผลิตปศุสัตว์อย่างยั่งยืน",
    newsSubHeader:
      "กรมปศุสัตว์เปิดเวทีความร่วมมืออาเซียนด้านสุขภาพสัตว์และผลิตภัณฑ์ปศุสัตว์ ย้ำบทบาทไทยในฐานะผู้นำภูมิภาค เดินหน้ายกระดับมาตรฐานการเลี้ยงสัตว์และการป้องกันโรค เสริมความเชื่อมั่นต่างประเทศ",
    newsImage: "/newsimage/news20250717p1.jpg",
    newsTags: ["ประชาสัมพันธ์", "กรมปศุสัตว์", "อาเซียน"],
    newsDate: "17 กรกฎาคม 2568",
  },
  {
    newsBadge: "update",
    newsSection: "ข่าวประชาสัมพันธ์",
    newsHeader:
      "กรมปศุสัตว์ร่วมเป็นสักขีพยานพิธีลงนามบันทึกข้อตกลงความร่วมมือคุมปริมาณสุกร",
    newsSubHeader:
      "กรมปศุสัตว์ร่วมเป็นสักขีพยานพิธีลงนามบันทึกข้อตกลงความร่วมมือคุมปริมาณสุกรให้สอดคล้องกับความต้องการบริโภคภายในประเทศ พร้อมประชุมคณะทำงานรักษาเสถียรภาพราคาสุกร ครั้งที่ 2/2568",
    newsImage: "/newsimage/news20250716p1.jpg",
    newsTags: ["ประชาสัมพันธ์", "สุกร", "กรมปศุสัตว์"],
    newsDate: "16 กรกฎาคม 2568",
  },
  {
    newsBadge: "hot",
    newsSection: "ข่าวประชาสัมพันธ์",
    newsHeader:
      "กรมปศุสัตว์ประชุมคณะกรรมการอำนวยการโครงการที่ได้รับการสนับสนุนเงินนอกงบประมาณชนิดสัตว์โคเนื้อ - กระบือ",
    newsSubHeader:
      "ประชุมคณะกรรมการอำนวยการโครงการที่ได้รับการสนับสนุนเงินนอกงบประมาณชนิดสัตว์โคเนื้อ - กระบือ ครั้งที่ 2/2568 เพื่อรับทราบและติดตามความก้าวหน้าผลการดำเนินงานโครงการต่างๆ",
    newsImage: "/newsimage/news20250716p2.jpg",
    newsTags: ["ประชาสัมพันธ์", "โคเนื้อ", "กระบือ", "กรมปศุสัตว์"],
    newsDate: "16 กรกฎาคม 2568",
  },
];